import { motion } from "framer-motion";

const reveal = (d) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, delay: d },
});

export const Hospice = () => (
  <section id="hospice" className="relative overflow-hidden bg-plum text-white" data-testid="hospice-section">
    <img src="/brand/nia-icon.png" alt="" aria-hidden="true"
      className="pointer-events-none absolute -right-16 -bottom-16 h-96 w-auto opacity-10" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-6 py-28 lg:grid-cols-12 lg:px-10 lg:py-36">
      <div className="lg:col-span-4">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Our philosophy</p>
        <motion.h2 {...reveal(0)} className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-testid="hospice-heading">
          Earth in <span className="text-gold">Hospice</span>
        </motion.h2>
      </div>
      <div className="space-y-8 lg:col-span-8">
        <motion.p {...reveal(0.1)} className="border-l-4 border-gold pl-6 font-display text-2xl font-medium leading-snug sm:text-3xl" data-testid="hospice-text">
          Our hospice philosophy asks us to meet ecological loss with presence, care, and responsibility. We tend what is
          wounded, honour what is passing, and nurture the possibilities still emerging.
        </motion.p>
        <motion.p {...reveal(0.2)} className="max-w-2xl text-lg leading-relaxed text-white/85" data-testid="hospice-learning-text">
          At Nia Ecoversity, ecological learning deepens our understanding of the relationships that sustain life and our
          responsibilities within them. Learning happens as we listen to the land, care for human and more-than-human
          communities, and contribute what we can. Healing grows through the care we practise together.
        </motion.p>
      </div>
    </div>
  </section>
);
